import {Component, Input, OnDestroy, Inject, ViewEncapsulation} from '@angular/core';
import {Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError} from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-spinner',
    standalone: true,
    imports: [CommonModule, NgxSpinnerModule],
    template: `<ngx-spinner bdColor="rgba(0, 0, 0, 0.5)" size="medium" color="#fff" type="ball-pulse" [fullScreen]="true" *ngIf="true">
      <p style="color: white" > Loading... </p>
    </ngx-spinner>
    <!-- 
      <div class="preloader" *ngIf="isSpinnerVisible">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
    </div>
    -->
    `,
    styles: `

    .preloader{
        position: absolute;
        margin: 0 auto;
        width: 100%;
        height: 100%;
      }
      .spinner {
        width: 40px;
        height: 40px;
        top:35%; 
        position: relative;
        margin: 100px auto;
      }
      
      .double-bounce1, .double-bounce2 {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #1976d2;
        opacity: 0.6;
        position: absolute;
        top: 0;
        left: 0;
        
        -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
        animation: sk-bounce 2.0s infinite ease-in-out;
      }
      
      .double-bounce2 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
      }
      
      @-webkit-keyframes sk-bounce {
        0%, 100% { -webkit-transform: scale(0.0) }
        50% { -webkit-transform: scale(1.0) }
      }
      
      @keyframes sk-bounce {
        0%, 100% { 
          transform: scale(0.0);
          -webkit-transform: scale(0.0);
        } 50% { 
          transform: scale(1.0);
          -webkit-transform: scale(1.0);
        }
    }`,
    encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {
    public isSpinnerVisible = true;
    
    @Input() public backgroundColor = 'rgba(0, 115, 170, 0.69)';
    
    constructor(private router: Router, @Inject(DOCUMENT) private document: Document, private spinner: NgxSpinnerService) {
        this.router.events.subscribe({
            next: (v) => {
              if(v instanceof NavigationStart){ this.isSpinnerVisible = true; spinner.show() } 
              else if(v instanceof NavigationEnd || v instanceof NavigationCancel) {
                this.isSpinnerVisible = false;
                spinner.hide();
              }
            },
            error: (e) => { if(e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError){this.isSpinnerVisible = false; spinner.hide()}},
        });
    }

    ngOnDestroy(): void {
        this.isSpinnerVisible = false;
        this.spinner.hide();
    }
}
